module.exports = __webpack_public_path__ + "img/left_md_1.fc83972a.jpg";